import { Routes } from '@angular/router';
import { PathService } from 'src/app/locale/services/path.service';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('src/app/front/views/layout/layout.component').then(m => m.LayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('src/app/front/views/home/home.component').then(m => m.HomeComponent),
            },
            {
                path: PathService.getRouterPath('contact'),
                loadComponent: () => import('src/app/front/views/contact/contact.component').then(m => m.ContactComponent),
            },
            {
                path: PathService.getRouterPath('fees'),
                loadComponent: () => import('src/app/front/views/fees/fees.component').then(m => m.FeesComponent),
            },
            {
                path: PathService.getRouterPath('rodo'),
                loadComponent: () => import('src/app/front/views/rodo/rodo.component').then(m => m.RodoComponent),
            },
            {
                path: PathService.getRouterPath('notarialActivities'),
                loadComponent: () => import('src/app/front/views/notarial-activities/notarial-activities.component').then(m => m.NotarialActivitiesComponent),
                children: [
                    {
                        path: PathService.getRouterPath('notarialActivities.inheritanceLaw'),
                        loadComponent: () => import('src/app/front/views/notarial-activities/inheritance-law/inheritance-law.component').then(m => m.InheritanceLawComponent),
                    },
                    {
                        path: PathService.getRouterPath('notarialActivities.familyLaw'),
                        loadComponent: () => import('src/app/front/views/notarial-activities/family-law/family-law.component').then(m => m.FamilyLawComponent),
                    },
                    {
                        path: PathService.getRouterPath('notarialActivities.realEstate'),
                        loadComponent: () => import('src/app/front/views/notarial-activities/real-estate/real-estate.component').then(m => m.RealEstateComponent),
                    },
                    {
                        path: PathService.getRouterPath('notarialActivities.certificates'),
                        loadComponent: () => import('src/app/front/views/notarial-activities/certificates/certificates.component').then(m => m.CertificatesComponent),
                    },
                ]
            }
        ]
    },
    {
        path: '**',
        redirectTo: '',
    },
];
